/*global jQuery, shop*/
(function($) {

  'use strict';

  const handleAjax = ($ajax) => $ajax
    .done((result) => {
      if (result.error) {
        shop.modalError(result.errorMessage);
        return;
      }
      location.reload();
    })
    .fail(function() {
      shop.modalError();
    });

  const selectPriceList = function() {
    const product = $(this).closest('tr').data('product');
    const list = $(this).data('list');
    const request = $.ajax({
      url: '/ajax/cart-select-price-list.php',
      type: 'POST',
      dataType: 'json',
      data: {product, list, language: shop.language}
    });
    handleAjax(request);
  };

  const increment = function() {
    const $row = $(this).closest('tr');
    const products = [{
      product: $row.data('product'),
      priceList: $row.data('priceList'),
      quantity: 1,
      option: $row.data('option'),
    }];
    handleAjax(shop.addToCart(products, shop.language));
  };
  const decrement = function() {
    const $row = $(this).closest('tr');
    if ($row.find('.quantity').val() > 1) {
      const products = [{
        product: $row.data('product'),
        priceList: $row.data('priceList'),
        quantity: 1,
        option: $row.data('option'),
      }];
      handleAjax(shop.removeFromCart(products, shop.language));
    }
    return false;
  };

  const removeProduct = function() {
    const $row = $(this).closest('tr');
    const products = [{
      product: $row.data('product'),
      priceList: $row.data('priceList'),
      quantity: $row.find('.quantity').val(),
      option: $row.data('option'),
    }];
    handleAjax(shop.removeFromCart(products, shop.language));
  };

  const emptyCart = function() {
    const message = 'Sei sicuro di voler svuotare il carrello?';
    const empty = () => handleAjax($.ajax({url: '/ajax/cart-empty.php'}));
    const buttons = [
      {text: 'Sì', action: empty, dismiss: true},
      {text: 'Annulla'}
    ];
    shop.modalConfirm(message, buttons);
  };

  const requireLogin = () => {
    const message = "Per proseguire è neccessario registrarsi o effettuare il login, clicca uno dei pulsanti qui sotto.";
    const signIn = () => shop.signIn({redirectUrl: shop.currentPage});
    const signUp = () => shop.signUp({redirectUrl: shop.currentPage});
    const signInButton = {text: 'Registrati', action: signUp};
    const signUpButton = {text: 'Vai alla login', action: signIn};
    const addListener = ($modal) => {
      $modal.find('.account-login').on('click', signIn);
      $modal.find('.account-register').on('click', signUp);
    };
    shop.modalError(message, [signInButton, signUpButton, {text: 'Chiudi'}],
      addListener);
  };

  const next = function() {
    //if (!shop.isLoggedIn) {
    //  requireLogin();
    //  return false;
    //}
    $(this).attr('href', $(this).data('next'));
    return true;
  };

  $('.cart-next').on('click', next);
  $('.cart-select-price-list').on('click', selectPriceList);
  $('.cart-decrement-quantity').on('click', decrement);
  $('.cart-increment-quantity').on('click', increment);
  $('.cart-remove-product').on('click', removeProduct);
  $('.cart-empty').on('click', emptyCart);

  
  
  


}(jQuery));
